import { supabase } from '@/integrations/supabase/client';

export const deleteAllUsersExcept = async (keepEmail: string) => {
  try {
    const { data, error } = await supabase.functions.invoke('admin-delete-users', {
      body: { keepEmail }
    });

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error deleting users:', error);
    throw error;
  }
};

export const deleteUserByEmail = async (email: string) => {
  try {
    const { data, error } = await supabase.functions.invoke('admin-delete-user', {
      body: { email }
    });

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};
